import { Alert, Box, Stack, Typography, Drawer } from '@mui/material';
import * as React from 'react';
import * as JSTool from '../../store/JSTool';
import { getImgPath } from '../../store/JSTool';
import $ from 'jquery';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../../store/SettingSlice';
import MobileMenu from './MobileMenu';
import MobileLanguage from './MobileLanguage';
import MobileProject from './MobileProject';
import * as rdd from 'react-device-detect';


export default function NavViewMobile(props) {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);

    React.useEffect(() => {
        dispatch(settingActions.setLanguage(JSTool.getLang()));
    }, []);

    function logoTap() {
        if (settingObj.showMenu) {
            JSTool.hideMenu();
        } else {
            navigate('/')
        }
    }

    function projectTap() {
        if (settingObj.showMenu) {
            JSTool.hideMenu();
        } else {
            JSTool.showMenu('_project_view');
        }
    }

    function menuTap() {
        if (settingObj.showMenu) {
            JSTool.hideMenu();
        } else {
            JSTool.showMenu('_menu_view');
        }
    }

    function languageTap() {
        if (settingObj.showMenu) {
            JSTool.hideMenu();
        } else {
            JSTool.showMenu('_language_view');
        }
    }

    return (
        <Stack
            id={props.navId && props.navId}
            sx={{
                position: 'absolute',
                width: 1,
                zIndex: 100,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                height: '50px',
            }}>

            <Box
                onClick={(logoTap)}
                component={'img'}
                src={getImgPath('logo_white.png')}
                sx={{
                    height: 0.5,
                    ml: 1.5,
                    cursor: 'pointer',
                }} />

            <Box sx={{ flex: 1 }} />

            <Box
                onClick={projectTap}
                component={'img'}
                src={getImgPath('game.png')}
                sx={{
                    height: '33px',
                    width: '33px',
                    mr: 2.5,
                    cursor: 'pointer',
                }} />

            <Box
                onClick={languageTap}
                component={'img'}
                src={getImgPath('language.png')}
                sx={{
                    height: '23px',
                    width: '23px',
                    mr: 8,
                    cursor: 'pointer',
                }} />

            {/* 菜单动画控件 */}
            <Box
                sx={{
                    mt: rdd.isIPad13 && 3,
                }}
                onClick={menuTap}
                component={'div'}
                className='btn-nav'>
                <i className="draw"></i>
            </Box>

            {/* 游戏 */}
            <MobileProject />

            {/* 语言 */}
            <MobileLanguage />

            {/* 菜单 */}
            <MobileMenu />

        </Stack>
    );
}

